import React, { useEffect, useState } from "react";



import { useParams } from "react-router-dom";
import { useSession } from "../Contexts/SessionContext";



import {



  TenderTreeAPI,



  RateGroupAPI,



  RateItemAPI,



  RateWorkGroupAPI,



  ThirdWBSAPI,



} from "../Services/Api";



import type {



  ActivityNode,



  ContractTreeNode,



  RateGroupItemRequest,



  RateItemRequest,



  RateWorkGroupRequest,



  AddSubWorksWbsNode,



} from "../Services/Api";



type ThirdWbsApiNode = {



  text?: string | null;



  tag?: number | null;



  wbsNo?: number | null;



  children?: ThirdWbsApiNode[];



  color?: string | null;



  front?: number | null;



  Text?: string | null;



  Tag?: number | null;



  WbsNo?: number | null;



  Children?: ThirdWbsApiNode[];



};



type WbsActivityApiRow = {



  text?: string | null;



  tag?: number | null;



  wbsNo?: number | null;



  Text?: string | null;



  Tag?: number | null;



  WbsNo?: number | null;



};



type WbsDisplayNode = {



  wbsNo: number;



  tag: number;



  name: string;



  children: WbsDisplayNode[];



};



// Legacy response type retained for the existing helper; Trade Item activity
// loading now uses a flat list and does not render this WBS tree.
type SubItemWbsNode = {
  wbsNo?: number | null;
  WbsNo?: number | null;
  treeNodeNo?: number | null;
  TreeNodeNo?: number | null;
  name?: string | null;
  Name?: string | null;
  wbsName?: string | null;
  WbsName?: string | null;
  text?: string | null;
  Text?: string | null;
  children?: SubItemWbsNode[];
  Children?: SubItemWbsNode[];
  activities?: any[];
  Activities?: any[];
};

// Keep the project wrapper (Tag = 0). The reference ThirdWBS screen uses



// that wrapper as UI level 0; its child WBS nodes are UI level 1.



const normalizeWbsTree = (input: any): WbsDisplayNode[] => {



  const roots: ThirdWbsApiNode[] = Array.isArray(input)



    ? input



    : input && typeof input === "object"



      ? [input]



      : [];



  const mapNodes = (nodes: ThirdWbsApiNode[]): WbsDisplayNode[] =>



    (nodes ?? []).flatMap((raw) => {



      const tag = Number(raw.tag ?? raw.Tag ?? 0);



      const children = raw.children ?? raw.Children ?? [];



      if (tag < 0) return [];



      return [{



        tag: Math.abs(tag),

        wbsNo: Math.abs(Number(raw.wbsNo ?? raw.WbsNo ?? tag)),



        name: String(raw.text ?? raw.Text ?? `WBS ${Math.abs(Number(raw.wbsNo ?? raw.WbsNo ?? tag))}`),



        children: mapNodes(children),



      }];



    });



  return mapNodes(roots);



};



const sortWbsNodes = (nodes: WbsDisplayNode[]): WbsDisplayNode[] => {



  return [...nodes]



    .sort((a, b) => {



      const aName = (a.name ?? "").trim();



      const bName = (b.name ?? "").trim();



      const aStartsWithNumber = /^\d+/.test(aName);



      const bStartsWithNumber = /^\d+/.test(bName);



      // Numbered WBS names first



      if (aStartsWithNumber && !bStartsWithNumber) return -1;



      if (!aStartsWithNumber && bStartsWithNumber) return 1;



      // Both start with numbers: sort numerically



      if (aStartsWithNumber && bStartsWithNumber) {



        const aNumber = Number(aName.match(/^\d+/)?.[0] ?? 0);



        const bNumber = Number(bName.match(/^\d+/)?.[0] ?? 0);



        if (aNumber !== bNumber) {



          return aNumber - bNumber;



        }



      }



      // Remaining names: alphabetical order



      return aName.localeCompare(bName, undefined, {



        sensitivity: "base",



        numeric: true,



      });



    })



    .map((node) => ({



      ...node,



      children: sortWbsNodes(node.children ?? []),



    }));



};



/* const normalizeActivityRows = (input: any): ActivityNode[] => {



  const rows: WbsActivityApiRow[] = Array.isArray(input)



    ? input



    : input?.data ?? input?.activities ?? input?.children ?? [];



  return rows



    .filter((row) => Number(row.tag ?? row.Tag ?? 0) < 0)



    .map((row) => {



      const tag = Number(row.tag ?? row.Tag ?? 0);



      return {



        activityNo: Math.abs(tag),



        activity: String(row.text ?? row.Text ?? "Unnamed Activity"),



      };



    });



}; */



const findWbsNode = (



  nodes: WbsDisplayNode[],



  targetWbsNo: number



): WbsDisplayNode | null => {



  for (const node of nodes) {



    if (node.wbsNo === targetWbsNo) {



      return node;



    }



    const found = findWbsNode(



      node.children ?? [],



      targetWbsNo



    );



    if (found) return found;



  }



  return null;



};



const normalizeActivityRows = (



  input: any,



  parentWbsNo: number | null = null



): ActivityNode[] => {



  const rows: WbsActivityApiRow[] = Array.isArray(input)



    ? input



    : input?.data ?? input?.activities ?? input?.children ?? [];



  return rows



    .filter((row) => Number(row.tag ?? row.Tag ?? 0) < 0)



    .map((row) => {



      const tag = Number(row.tag ?? row.Tag ?? 0);



      const rowWbsNo = Number(



        row.wbsNo ?? row.WbsNo ?? parentWbsNo ?? 0



      );



      return {



        activityNo: Math.abs(tag),



        activity: String(



          row.text ?? row.Text ?? "Unnamed Activity"



        ),



        wbsNo: rowWbsNo > 0 ? rowWbsNo : null,



      };



    });



};



type TenderDetailsProps = {



  selectedContractNode?: ContractTreeNode | null;



  onItemsAdded?: () => void;



  mode?: "rateGroup" | "subItem" | "workGroup";



  selectedRateGroupNo?: number | null;



  selectedWbsNo?: number | null;

  parentRateType?: "Trade Item" | "Stage Item";

};



/**



 * TradeItem screen.



 *



 * Rules:



 * - Activity list always comes from dbo.ActivityWBS with @lvl = 0.



 * - Direct Add Item: ContractNode = 0.



 * - Add Item from a selected section:



 *      ContractNode = selected section's ContractNodeNo.



 * - Rider = ActivityNo.



 * - Stage = 0.



 * - Contract = TenderNo.



 * - Unit = NULL.



 * - RateType = "Trade Item".



 *



 * IMPORTANT:



 * - The same Activity CAN be added multiple times.



 * - There is NO frontend "already added" freezing logic.



 */



const TenderDetails: React.FC<TenderDetailsProps> = ({



  selectedContractNode,



  onItemsAdded,



  mode = "rateGroup",



  selectedRateGroupNo = null,



  selectedWbsNo = null,

  parentRateType = "Trade Item",



}) => {



  const { tenderNo } = useParams<{ tenderNo: string }>();



  const tenderNumber = Number(tenderNo);
  const { sessionNo } = useSession();
  const activeSessionNo = Number(sessionNo);



  const [activities, setActivities] =



    useState<ActivityNode[]>([]);



  const [projectNo, setProjectNo] = useState<number | null>(null);



  const [wbsLevel, setWbsLevel] = useState(0);



  const [wbsTree, setWbsTree] = useState<WbsDisplayNode[]>([]);



  const [expandedWbs, setExpandedWbs] = useState<Set<number>>(new Set());



  const [wbsActivities, setWbsActivities] = useState<Record<number, ActivityNode[]>>({});



  const [loadingWbs, setLoadingWbs] = useState(false);



  const [loadingWbsActivities, setLoadingWbsActivities] = useState<Set<number>>(new Set());

  const [subItemActivities, setSubItemActivities] = useState<ActivityNode[]>([]);
  const [subItemWbsTree, setSubItemWbsTree] = useState<SubItemWbsNode[]>([]);



  // Multiple WorkGroups can be selected together in Add Sub Works mode.
  const [selectedWorkGroups, setSelectedWorkGroups] =
    useState<Set<number>>(new Set());

  // Hierarchical WBS tree used only by Add Sub Works mode.
  const [addSubWorksTree, setAddSubWorksTree] =
    useState<AddSubWorksWbsNode[]>([]);
  // Flat WorkGroups are returned when the selected Trade Item has no WBS.
  const [flatWorkGroups, setFlatWorkGroups] = useState<any[]>([]);
  const [expandedSubWorksWbs, setExpandedSubWorksWbs] =
    useState<Set<number>>(new Set());



  


 const [selectedActivities, setSelectedActivities] =
    useState<Set<string>>(new Set());

  // An activity is identified by BOTH its WBS and ActivityNo.
  // This prevents the same ActivityNo under different WBS nodes
  // from sharing the same checkbox selection.
  const activitySelectionKey = (wbsNo: number | null | undefined, activityNo: number) =>
    `${Number(wbsNo ?? 0)}:${Number(activityNo)}`; 
    


  const [loading, setLoading] =



    useState(true);



  const [adding, setAdding] =



    useState(false);



  const [error, setError] =



    useState("");



  const [addMessage, setAddMessage] =



    useState("");



  const [addError, setAddError] =



    useState("");



  // ============================================================



  // LOAD ACTIVITIES / WORKGROUPS



  // ============================================================



  useEffect(() => {



    let cancelled = false;



    const loadData = async () => {



      if (



        !Number.isInteger(tenderNumber) ||



        tenderNumber <= 0



      ) {



        if (!cancelled) {



          setActivities([]);






          setProjectNo(null);



          setWbsTree([]);



          setWbsActivities({});



          setExpandedWbs(new Set());



          setLoading(false);



        }



        return;



      }



      try {



        setLoading(true);



        setError("");



        // ======================================================



        // WORKGROUP MODE



        // ======================================================



        if (mode === "workGroup") {
          // Pass the selected parent for both types. The backend scopes Trade
          // Items by RateGroup.WbsNo and preserves the existing Stage Item rules.
          const result = await TenderTreeAPI.getAddSubWorksTree(
            tenderNumber,
            selectedRateGroupNo ?? undefined,
            parentRateType
          );

          if (!cancelled) {
            const response = result as any;
            const rawFlatWorkGroups =
              response.workGroups ?? response.WorkGroups ?? [];

            setFlatWorkGroups(
              Array.isArray(rawFlatWorkGroups) ? rawFlatWorkGroups : []
            );
            setAddSubWorksTree(
              Array.isArray(response.data) ? response.data : []
            );
            setExpandedSubWorksWbs(new Set());
            setSelectedWorkGroups(new Set());
            setProjectNo(response.projectNo ?? response.ProjectNo ?? null);
          }

          return;
        }



        // ======================================================



        // ACTIVITY MODE



        // ======================================================



        // Backend executes dbo.ActivityWBS with @lvl = 0.



        const data =



          await TenderTreeAPI.getByTender(



            tenderNumber



          );



        if (!cancelled) {



          setActivities(data.activities || []);



          const resolvedProjectNo = Number(data.project);



          setProjectNo(Number.isInteger(resolvedProjectNo) && resolvedProjectNo > 0 ? resolvedProjectNo : null);



        }



      } catch (err: any) {



        console.error(



          mode === "workGroup"



            ? "Unable to load WorkGroups:"



            : "Unable to load Activities:",



          err



        );



        if (!cancelled) {



          setError(



            err?.response?.data?.message ||



              err?.message ||



              (mode === "workGroup"



                ? "Unable to load WorkGroups."



                : "Unable to load Activities.")



          );



          if (mode === "workGroup") {






          } else {



            setActivities([]);



          }



        }



      } finally {



        if (!cancelled) {



          setLoading(false);



        }



      }



    };



    loadData();



    return () => {



      cancelled = true;



    };



  }, [tenderNumber, mode, selectedRateGroupNo, parentRateType]);



  // Match the existing ThirdWBS screen: UI level 0 is the project wrapper;



  // UI level 1 shows its root WBS children, UI level 2 shows one deeper level.



  useEffect(() => {

    let cancelled = false;



    const loadWbs = async () => {

      /* if (mode === "workGroup" || !projectNo || projectNo <= 0) {

        setWbsTree([]);

        setSubItemActivities([]);

        return;

      } */
     
if (
  mode === "workGroup" ||
  (mode !== "subItem" && (!projectNo || projectNo <= 0))
) {
  setWbsTree([]);
  setSubItemActivities([]);
  setSubItemWbsTree([]);
  return;
}




      try {

        setLoadingWbs(true);

        setError("");

        setWbsTree([]);

        setWbsActivities({});

        setSelectedActivities(new Set());



        // Add Sub Item: load activities using the selected RateGroupNo.
        // Trade Item activities are returned as a flat list independent of WBS.
        // Stage Item loading retains its existing behavior.
        if (mode === "subItem") {
          setSubItemActivities([]);

          if (
            selectedRateGroupNo == null ||
            !Number.isInteger(Number(selectedRateGroupNo)) ||
            Number(selectedRateGroupNo) <= 0
          ) {
            if (!cancelled) {
              setError("Invalid selected Trade Item RateGroupNo.");
            }
            return;
          }

        
/* const response = await TenderTreeAPI.getSubItemActivities(
  Number(selectedRateGroupNo)
);
 */

const response =
  parentRateType === "Stage Item"
    ? await TenderTreeAPI.getStageItemActivities(
        Number(selectedRateGroupNo)
      )
    : await TenderTreeAPI.getSubItemActivities(
        Number(selectedRateGroupNo)
      );

if (parentRateType === "Stage Item") {
            // Stage Item response and behavior remain unchanged.
            const rawActivities = response?.activities ?? [];
            const rows: ActivityNode[] = rawActivities.map((item: any) => ({
              activityNo: Number(item.activityNo ?? item.ActivityNo),
              activity: String(
                item.activity ?? item.Activity ?? "Unnamed Activity"
              ),
              wbsNo: Number(item.wbsNo ?? item.WbsNo ?? 0) || null,
            }));

            if (!cancelled) {
              setSubItemActivities(rows);
              setSubItemWbsTree([]);
              setSelectedActivities(new Set());
              setError("");
            }
          } else {
            // Trade Item: Activityforrateworkgroup returns a flat activity list
            // based on RateGroupNo only. WBS is not used to filter or display
            // these activities.
            const responseData = response as any;
            const rawActivities =
              responseData?.activities ?? responseData?.Activities ?? [];

            const flatRows: ActivityNode[] = Array.isArray(rawActivities)
              ? rawActivities
                  .map((item: any) => ({
                    activityNo: Number(item.activityNo ?? item.ActivityNo),
                    activity: String(
                      item.activity ?? item.Activity ?? "Unnamed Activity"
                    ),
                    wbsNo: null,
                  }))
                  .filter(
                    (item: ActivityNode) =>
                      item.activityNo != null &&
                      Number.isInteger(item.activityNo) &&
                      item.activityNo > 0
                  )
              : [];

            if (!cancelled) {
              setSubItemActivities(flatRows);
              // Add Sub Item activity list must never render a WBS tree.
              setSubItemWbsTree([]);
              setSelectedActivities(new Set());
              setError("");
            }
          }
          return;
        }

        // Existing Add Item behavior: keep the WBS tree and level selector.

        setSubItemActivities([]);

        // projectNo is required for loading the regular WBS tree.
if (projectNo == null || projectNo <= 0) {
  setWbsTree([]);
  setWbsActivities({});
  return;
}


        const response = await ThirdWBSAPI.getTree(projectNo, wbsLevel);

        const normalizedTree = sortWbsNodes(normalizeWbsTree(response));



        if (!cancelled) {

          setWbsTree(normalizedTree);

          setExpandedWbs(new Set([0]));

          setWbsActivities({});

        }



        // Level 0 displays activities directly under the project wrapper.

        if (wbsLevel === 0) {

          const rootActivities = normalizeActivityRows(

            await ThirdWBSAPI.getActivities(projectNo, 0, 0),

            0

          );



          if (!cancelled) {

            setWbsActivities({ 0: rootActivities });

            setActivities((previous) => {

              const merged = new Map<number, ActivityNode>();

              [...previous, ...rootActivities].forEach((item) => {

                if (item.activityNo != null) merged.set(item.activityNo, item);

              });

              return Array.from(merged.values());

            });

          }

        }

      } catch (err: any) {

        if (!cancelled) {

          setWbsTree([]);

          setSubItemActivities([]);

          setError(

            err?.response?.data?.message ||

              err?.message ||

              (mode === "subItem"

                ? "Unable to load activities for the selected WBS."

                : "Unable to load WBS tree.")

          );

        }

      } finally {

        if (!cancelled) setLoadingWbs(false);

      }

    };



    void loadWbs();

    return () => {

      cancelled = true;

    };

  }, [projectNo, wbsLevel, mode, selectedRateGroupNo,parentRateType]);



  const toggleWbsNode = async (node: WbsDisplayNode) => {



    const isExpanded = expandedWbs.has(node.wbsNo);



    if (isExpanded) {



      setExpandedWbs((previous) => {



        const next = new Set(previous);



        next.delete(node.wbsNo);



        return next;



      });



      return;



    }



    setExpandedWbs((previous) => new Set(previous).add(node.wbsNo));



    if (!projectNo || wbsActivities[node.wbsNo]) return;



    setLoadingWbsActivities((previous) => new Set(previous).add(node.wbsNo));



    try {



      // Match ThirdWBS: request activities for this node at the selected level.



     /*  const rows = normalizeActivityRows(



        await ThirdWBSAPI.getActivities(projectNo, node.wbsNo, wbsLevel)



      ); */



      /* const rows = normalizeActivityRows(



  await ThirdWBSAPI.getActivities(



    projectNo,



    node.wbsNo,



    wbsLevel



  ),



  node.wbsNo



); */



const rows = normalizeActivityRows(



  await ThirdWBSAPI.getActivities(



    projectNo,



    node.wbsNo,



    mode === "subItem" ? 0 : wbsLevel



  ),



  node.wbsNo



);



      setWbsActivities((previous) => ({ ...previous, [node.wbsNo]: rows }));



      setActivities((previous) => {



        const merged = new Map<number, ActivityNode>();



        previous.forEach((item) => {



          if (item.activityNo != null) merged.set(item.activityNo, item);



        });



        rows.forEach((item) => {



          if (item.activityNo != null) merged.set(item.activityNo, item);



        });



        return Array.from(merged.values());



      });



    } catch (err: any) {



      setError(err?.response?.data?.message || err?.message || `Unable to load activities for ${node.name}.`);



    } finally {



      setLoadingWbsActivities((previous) => {



        const next = new Set(previous);



        next.delete(node.wbsNo);



        return next;



      });



    }



  };



  const renderWbsNodes = (nodes: WbsDisplayNode[], depth = 0): React.ReactNode =>



    nodes.map((node) => {



      const expanded = expandedWbs.has(node.wbsNo);



     // const isActivityLevel = depth === wbsLevel;



     const isActivityLevel =



  mode === "subItem"



    ? depth === 0



    : depth === wbsLevel;



      const rows = wbsActivities[node.wbsNo] ?? [];



      const canExpand = (depth < wbsLevel && node.children.length > 0) || isActivityLevel;



      return (



        <div key={`${node.tag}-${node.wbsNo}`} className="mb-1">



          <button



            type="button"



            onClick={() => canExpand && void toggleWbsNode(node)}



            disabled={!canExpand || loadingWbsActivities.has(node.wbsNo) || adding}



            className="flex w-full items-center gap-2 rounded px-2 py-2 text-left hover:bg-gray-50 disabled:cursor-default disabled:opacity-100"



            style={{ paddingLeft: `${8 + depth * 16}px` }}



          >



            <span className="w-4 shrink-0 text-center text-xs text-gray-500">



              {loadingWbsActivities.has(node.wbsNo) ? "…" : canExpand ? (expanded ? "▾" : "▸") : ""}



            </span>



            <span className={`text-sm ${node.tag === 0 ? "font-medium text-green-700" : "font-medium text-gray-800"}`}>



              {node.name}



            </span>



          </button>



          {expanded && (



            <div className="ml-2 border-l border-gray-200">



              {depth < wbsLevel && node.children.length > 0 &&



                renderWbsNodes(node.children, depth + 1)}



              {isActivityLevel && (



                <>



                  {loadingWbsActivities.has(node.wbsNo) && (



                    <div className="py-2 pl-8 text-xs text-gray-500">Loading activities...</div>



                  )}



                  {!loadingWbsActivities.has(node.wbsNo) && rows.length === 0 && (



                    <div className="py-2 pl-8 text-xs text-gray-400">No activities under this WBS.</div>



                  )}



                  {rows.map((activity) => {



                    const activityNo = activity.activityNo;



                    if (activityNo == null) return null;



                    return (



                      <label key={`${node.wbsNo}-${activityNo}`} className="flex cursor-pointer items-center gap-2 border-b border-gray-100 px-3 py-2 hover:bg-gray-50" style={{ paddingLeft: `${30 + depth * 16}px` }}>



                        <input type="checkbox" className="h-4 w-4" checked={selectedActivities.has(activitySelectionKey(activity.wbsNo ?? node.wbsNo, activityNo))} disabled={adding} onChange={() => toggleActivity(activity.wbsNo ?? node.wbsNo, activityNo)} />



                        <span className="flex-1 text-sm text-gray-700">{activity.activity || "Unnamed Activity"}</span>
                       



                      </label>



                    );



                  })}



                </>



              )}



            </div>



          )}



        </div>



      );



    });



  // ============================================================



  // CLEAR SELECTION WHEN SECTION CHANGES



  // ============================================================



  useEffect(() => {



    setSelectedActivities(new Set());



    setSelectedWorkGroups(new Set());



    setAddMessage("");



    setAddError("");



  }, [selectedContractNode?.contractNodeNo]);



  // ============================================================



  // TOGGLE ACTIVITY



  //



  // IMPORTANT:



  // There is NO check against previously added Activities.



  // Therefore the same Activity can be selected again.



  // ============================================================



  const toggleActivity = (
    wbsNo: number | null | undefined,
    activityNo: number
  ) => {
    const selectionKey = activitySelectionKey(wbsNo, activityNo);



    setSelectedActivities((previous) => {



      const next = new Set(previous);



      if (next.has(selectionKey)) {
        next.delete(selectionKey);
      } else {
        next.add(selectionKey);
      }



      return next;



    });



  };



  // ============================================================



  // BUILD RATE GROUP REQUEST



  // ============================================================



  const buildRateGroupItem = (



    activity: ActivityNode



  ): RateGroupItemRequest | null => {



    if (activity.activityNo == null) {



      return null;



    }



    return {



      rateGroup:



        activity.activity || "Activity",



      // Direct Add Item = 0.



      // Section Add Item =



      // selected ContractNodeNo.



      contractNode:



        selectedContractNode?.contractNodeNo ?? 0,



      // Activity number.



      rider: activity.activityNo,



      wbsNo: activity.wbsNo ?? null,



      // TradeItem always uses Stage 0.



      stage: 0,



      // Tender number.



      contract: tenderNumber,



      // TradeItem does not use GeometryType/Unit.



      unit: null,



      // Rate Type passed from frontend.



      rateType: "Trade Item",



    };



  };



  // ============================================================



  // ADD SELECTED ITEMS



  // ============================================================



  const handleAddItems = async () => {



    setAddMessage("");



    setAddError("");



    if (!Number.isInteger(activeSessionNo) || activeSessionNo <= 0) {
      setAddError(
        "No valid session found. Please return to the Dashboard and reopen the project."
      );
      return;
    }

    if (



      !Number.isInteger(tenderNumber) ||



      tenderNumber <= 0



    ) {



      setAddError("Invalid Tender No.");



      return;



    }



    if (selectedActivities.size === 0) {



      setAddError(



        "Please select at least one Activity."



      );



      return;



    }



    try {



      setAdding(true);



      const selectedItems:



        RateGroupItemRequest[] = [];



      activities.forEach((activity) => {



        if (activity.activityNo == null) {



          return;



        }



        // Only check whether the Activity



        // is currently selected.



        //



        // DO NOT check whether it was



        // previously added.



        if (
          !selectedActivities.has(
            activitySelectionKey(activity.wbsNo, activity.activityNo)
          )
        ) {



          return;



        }



        const item =



          buildRateGroupItem(activity);



        if (item) {



          selectedItems.push(item);



        }



      });



      if (selectedItems.length === 0) {



        setAddError(



          "No valid Activities selected."



        );



        return;



      }



      const result =



        await RateGroupAPI.addItems(
          selectedItems,
          activeSessionNo
        );



      setAddMessage(



        result.message ||



          `${result.addedCount} item(s) added successfully.`



      );



      // Clear only the current checkbox selection.



      // The Activity itself remains available



      // for selecting and adding again.



      setSelectedActivities(new Set());



      onItemsAdded?.();



    } catch (err: any) {



      console.error(



        "Add RateGroup Items Error:",



        err



      );



      setAddError(



        err?.response?.data?.error ||



          err?.response?.data?.message ||



          err?.message ||



          "Unable to add items."



      );



    } finally {



      setAdding(false);



    }



  };



  // ============================================================



  // ADD SELECTED SUB ITEMS



  // ============================================================



  const handleAddSubItems = async () => {



    setAddMessage("");



    setAddError("");



    if (!Number.isInteger(activeSessionNo) || activeSessionNo <= 0) {
      setAddError(
        "No valid session found. Please return to the Dashboard and reopen the project."
      );
      return;
    }

    if (



      !selectedRateGroupNo ||



      selectedRateGroupNo <= 0



    ) {



      setAddError(



        "Invalid Trade Item RateGroup."



      );



      return;



    }



    if (selectedActivities.size === 0) {



      setAddError(



        "Please select at least one Activity."



      );



      return;



    }



    try {



      setAdding(true);



      // ActivityNo is intentionally NOT stored.



      // One RateItems row is created for each



      // selected Activity, using only the selected



      // Trade Item RateGroupNo.



      const requestItems: RateItemRequest[] =



        Array.from(selectedActivities).map((selectionKey) => {
          const activityNo = Number(selectionKey.split(":")[1]);
          return {
            rateGroup: selectedRateGroupNo,
            // Keep the existing API payload's activity identifier.
            procedure: activityNo,



            // Existing Sub Item behavior.



            workGroup: 0,
          };
        });



      const result =



        await RateItemAPI.addItems(
          requestItems,
          activeSessionNo
        );



      setAddMessage(



        result.message ||



          `${result.addedCount} sub item(s) added successfully.`



      );



      setSelectedActivities(new Set());



      onItemsAdded?.();



    } catch (err: any) {



      console.error(



        "Add Sub Items Error:",



        err



      );



      setAddError(



        err?.response?.data?.error ||



          err?.response?.data?.message ||



          err?.message ||



          "Unable to add sub items."



      );



    } finally {



      setAdding(false);



    }



  };



  // ============================================================



  // SELECT WORKGROUP



  // ============================================================



  const handleAddWorkGroup = async () => {



    setAddMessage("");



    setAddError("");



    if (!Number.isInteger(activeSessionNo) || activeSessionNo <= 0) {
      setAddError(
        "No valid session found. Please return to the Dashboard and reopen the project."
      );
      return;
    }

    if (



      !selectedRateGroupNo ||



      selectedRateGroupNo <= 0



    ) {



      setAddError(



        "Invalid Trade Item RateGroup."



      );



      return;



    }



    if (selectedWorkGroups.size === 0) {
      setAddError("Please select at least one WorkGroup.");
      return;
    }



    try {



      setAdding(true);



      const requestItems: RateWorkGroupRequest[] =
        Array.from(selectedWorkGroups).map((workGroupNo) => ({
          rateGroup: selectedRateGroupNo,
          workGroup: workGroupNo,
        }));


      const result =



        await RateWorkGroupAPI.addItems(
          requestItems,
          activeSessionNo
        );



      setAddMessage(



        result.message ||



          `${result.addedCount} sub work(s) added successfully.`



      );



      setSelectedWorkGroups(new Set());



      onItemsAdded?.();



    } catch (err: any) {



      console.error(



        "Add Sub Works Error:",



        err



      );



      setAddError(



        err?.response?.data?.error ||



          err?.response?.data?.message ||



          err?.message ||



          "Unable to add sub works."



      );



    } finally {



      setAdding(false);



    }



  };



// Render the WBS hierarchy and the WorkGroups attached to each WBS.
  // This renderer is used only in mode="workGroup" (Add Sub Works).
  const renderAddSubWorksNodes = (
    nodes: AddSubWorksWbsNode[],
    depth = 0
  ): React.ReactNode =>
    nodes.map((node) => {
      const expanded = expandedSubWorksWbs.has(node.treeNodeNo);
      const children = node.children ?? [];
      const groups = node.workGroups ?? [];
      const canExpand = children.length > 0 || groups.length > 0;

      return (
        <div key={node.treeNodeNo} className="mb-1">
          <button
            type="button"
            disabled={!canExpand || adding}
            onClick={() => {
              if (!canExpand) return;
              setExpandedSubWorksWbs((previous) => {
                const next = new Set(previous);
                if (next.has(node.treeNodeNo)) next.delete(node.treeNodeNo);
                else next.add(node.treeNodeNo);
                return next;
              });
            }}
            className="flex w-full items-center gap-2 rounded px-2 py-2 text-left hover:bg-gray-50 disabled:cursor-default disabled:opacity-100"
            style={{ paddingLeft: `${8 + depth * 16}px` }}
          >
            <span className="w-4 shrink-0 text-center text-xs text-gray-500">
              {canExpand ? (expanded ? "▾" : "▸") : ""}
            </span>
            <span className="flex-1 text-sm font-semibold text-gray-800">
              {node.workTreeName || node.description || `WBS ${node.treeNodeNo}`}
            </span>
            {groups.length > 0 && (
              <span className="text-xs text-gray-500">
                {groups.length} {groups.length === 1 ? "WorkGroup" : "WorkGroups"}
              </span>
            )}
          </button>

          {expanded && (
            <div className="ml-2 border-l border-gray-200">
              {groups.map((workGroup) => {
                const selected = selectedWorkGroups.has(workGroup.workGroupNo);
                return (
                  <label
                    key={workGroup.workGroupNo}
                    className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 ${
                      selected
                        ? "border-[#53538c] bg-[#eef0ff]"
                        : "border-transparent bg-white hover:bg-gray-50"
                    }`}
                    style={{ paddingLeft: `${30 + depth * 16}px` }}
                  >
                    <input
                      type="checkbox"
                      className="h-4 w-4 accent-[#53538c]"
                      checked={selected}
                      disabled={adding}
                      onChange={() => {
                        setSelectedWorkGroups((previous) => {
                          const next = new Set(previous);
                          if (next.has(workGroup.workGroupNo)) {
                            next.delete(workGroup.workGroupNo);
                          } else {
                            next.add(workGroup.workGroupNo);
                          }
                          return next;
                        });
                      }}
                    />
                    <span className="flex-1 text-sm text-gray-700">
                      <span className="mr-2 font-semibold text-gray-500">
                        [{workGroup.workGroupNo}]
                      </span>
                      {workGroup.workGroup || workGroup.workGroupDesc || "Unnamed WorkGroup"}
                    </span>
                  </label>
                );
              })}
              {children.length > 0 && renderAddSubWorksNodes(children, depth + 1)}
            </div>
          )}
        </div>
      );
    });

  // ============================================================

  // UI



  // ============================================================



  return (



    <div className="w-full h-full bg-white flex flex-col">



      {/* Header */}



      <div className="px-4 py-3 border-b border-gray-200">



        <h2 className="text-sm font-semibold text-gray-700">



          {mode === "workGroup"



            ? "WBS and Sub Works"



            : "WBS and Activities"}



        </h2>



      </div>



      {/* Content */}



      <div className="flex-1 overflow-y-auto p-3">



        {loading && (



          <div className="text-sm text-gray-500">



            {mode === "workGroup"



              ? "Loading WBS and Sub Works..."



              : "Loading WBS and activities..."}



          </div>



        )}



        {!loading && error && (



          <div className="text-sm text-red-500">



            {error}



          </div>



        )}



        {/* ======================================================



            WORKGROUP MODE



        ====================================================== */}



        {mode === "workGroup" && !loading && !error && (
          <div className="space-y-1">
            {addSubWorksTree.length > 0 ? (
              // Always render WBS hierarchy. When the Trade Item has no WBS,
              // the backend returns the complete project's WBS/WorkGroup tree.
              renderAddSubWorksNodes(addSubWorksTree)
            ) : flatWorkGroups.length > 0 ? (
              // Compatibility fallback for older backend responses.
              flatWorkGroups.map((group: any, index: number) => {
                const workGroupNo = Number(
                  group.workGroupNo ?? group.WorkGroupNo ?? group.workGroupNoId
                );
                const workGroupName = String(
                  group.workGroup ?? group.WorkGroup ?? group.workGroupDesc ?? group.WorkGroupDesc ?? ""
                );
                if (!Number.isInteger(workGroupNo) || workGroupNo <= 0) return null;
                const selected = selectedWorkGroups.has(workGroupNo);
                return (
                  <label key={`${workGroupNo}-${index}`} className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 ${selected ? "border-[#53538c] bg-[#eef0ff]" : "border-transparent bg-white hover:bg-gray-50"}`}>
                    <input type="checkbox" className="h-4 w-4 accent-[#53538c]" checked={selected} disabled={adding} onChange={() => setSelectedWorkGroups((previous) => { const next = new Set(previous); if (next.has(workGroupNo)) next.delete(workGroupNo); else next.add(workGroupNo); return next; })} />
                    <span className="flex-1 text-sm text-gray-700"><span className="mr-2 font-semibold text-gray-500">[{workGroupNo}]</span>{workGroupName || `WorkGroup ${workGroupNo}`}</span>
                  </label>
                );
              })
            ) : (
              <div className="text-sm text-gray-500">
                No active WorkGroups were found.
              </div>
            )}
          </div>
        )}

        {/* WBS LEVEL + ACTIVITY LIST */}



        {mode !== "workGroup" && !loading && !error && (

          <div className="space-y-3">

            {mode !== "subItem" && (

              <div className="flex items-center gap-2">

                <label htmlFor="wbs-level" className="text-xs font-medium text-gray-600">

                  Level

                </label>

                <select

                  id="wbs-level"

                  value={wbsLevel}

                  onChange={(event) => setWbsLevel(Number(event.target.value))}

                  className="rounded border border-gray-300 bg-white px-2 py-1 text-sm text-gray-700"

                >

                  {Array.from({ length: 11 }, (_, level) => (

                    <option key={level} value={level}>{level}</option>

                  ))}

                </select>

              </div>

            )}



            {loadingWbs && (

              <div className="text-sm text-gray-500">

                {mode === "subItem" ? "Loading activities..." : "Loading WBS..."}

              </div>

            )}



            {!loadingWbs && mode === "subItem" && (
              <div className="space-y-1">
                {parentRateType === "Trade Item" ? (
                  subItemActivities.length > 0 ? (
                    subItemActivities.map((activity, index) => {
                      const activityNo = activity.activityNo;
                      if (activityNo == null) return null;

                      // Trade Item sub-item activities are independent of WBS.
                      const key = activitySelectionKey(null, activityNo);

                      return (
                        <label
                          key={`${key}-${index}`}
                          className="flex cursor-pointer items-center gap-2 border-b border-gray-100 px-3 py-2 hover:bg-gray-50"
                        >
                          <input
                            type="checkbox"
                            className="h-4 w-4"
                            checked={selectedActivities.has(key)}
                            disabled={adding}
                            onChange={() => toggleActivity(null, activityNo)}
                          />
                          <span className="flex-1 text-sm text-gray-700">
                            {activity.activity || "Unnamed Activity"}
                          </span>
                        </label>
                      );
                    })
                  ) : (
                    <div className="text-sm text-gray-500">
                      No activities found.
                    </div>
                  )
                ) : subItemActivities.length > 0 ? (
                  subItemActivities.map((activity) => {
                    const activityNo = activity.activityNo;
                    if (activityNo == null) return null;
                    const wbsNo = activity.wbsNo ?? selectedWbsNo;
                    const key = activitySelectionKey(wbsNo, activityNo);

                    return (
                      <label
                        key={key}
                        className="flex cursor-pointer items-center gap-2 border-b border-gray-100 px-3 py-2 hover:bg-gray-50"
                      >
                        <input
                          type="checkbox"
                          className="h-4 w-4"
                          checked={selectedActivities.has(key)}
                          disabled={adding}
                          onChange={() => toggleActivity(wbsNo, activityNo)}
                        />
                        <span className="flex-1 text-sm text-gray-700">
                          {activity.activity || "Unnamed Activity"}
                        </span>
                      </label>
                    );
                  })
                ) : (
                  <div className="text-sm text-gray-500">
                    No activities found for this Stage Item.
                  </div>
                )}
              </div>
            )}


            {!loadingWbs && mode !== "subItem" && wbsTree.length === 0 && (

              <div className="text-sm text-gray-500">No WBS nodes found for this level.</div>

            )}

            {!loadingWbs && mode !== "subItem" && wbsTree.length > 0 && (

              <div className="space-y-1">{renderWbsNodes(wbsTree)}</div>

            )}

          </div>

        )}



      </div>



      {/* Status */}



      {(addMessage || addError) && (



        <div className="px-4 py-2 border-t border-gray-200">



          {addMessage && (



            <div className="text-sm text-green-600">



              {addMessage}



            </div>



          )}



          {addError && (



            <div className="text-sm text-red-500">



              {addError}



            </div>



          )}



        </div>



      )}



      {/* Bottom Button */}



      <div className="px-4 py-3 border-t border-gray-200 flex justify-end gap-2">



        <button



          type="button"



          onClick={



            mode === "subItem"



              ? handleAddSubItems



              : mode === "workGroup"



                ? handleAddWorkGroup



                : handleAddItems



          }



          disabled={



            adding ||



            (mode === "workGroup"



              ? selectedWorkGroups.size === 0



              : selectedActivities.size === 0)



          }



          className="px-4 py-2 text-sm font-medium text-white bg-[#53538c] rounded hover:bg-[#454575] disabled:bg-gray-300 disabled:cursor-not-allowed"



        >



          {adding



            ? "Adding..."



            : mode === "subItem"



              ? "Add to Sub Item"



              : mode === "workGroup"



                ? "Add Sub Works"



                : "Add Item"}



        </button>



      </div>



    </div>



  );



};



export default TenderDetails;
